import type { ReactNode } from "react";

/*
 * A small status label in sentence case. Warning and danger carry a coloured
 * dot with dark text, so the label stays readable on its pale fill.
 */
const tones = {
  neutral: "bg-hazumu-border text-hazumu-muted",
  success: "bg-hazumu-sage-pale text-hazumu-sage-deep",
  warning: "bg-hazumu-gold-pale text-hazumu-ink before:bg-hazumu-gold-deep",
  danger: "bg-hazumu-blush text-hazumu-ink before:bg-hazumu-danger",
  strong: "bg-hazumu-ink text-hazumu-warm-white",
} as const;

export type BadgeTone = keyof typeof tones;

export const Badge = ({
  tone = "neutral",
  className = "",
  children,
}: {
  tone?: BadgeTone;
  className?: string;
  children: ReactNode;
}) => (
  <span
    className={`inline-flex shrink-0 items-center gap-1 rounded-full px-2 py-0.5 text-[11px] leading-4 font-medium whitespace-nowrap [&_svg]:shrink-0 ${tone === "warning" || tone === "danger" ? "before:size-1.5 before:rounded-full before:content-['']" : ""} ${tones[tone]} ${className}`}
  >
    {children}
  </span>
);
